import PropTypes from "prop-types";
import classes from "./Label.module.scss";

export const Label = ({ text }) => {
  return (
    <div className={classes["label"]} data-testid={"label-wrapper"}>
      {text}
    </div>
  );
};

Label.propTypes = {
  /**
   * text of the label
   */
  text: PropTypes.string.isRequired,
};

Label.defaultProps = {
  text: "",
};
